<script setup lang="ts">
import { computed } from 'vue'

import { Participant } from '@collector/sportsapi-client-legacy'

import { getParticipantTeamSide } from '../utils'

interface Props {
  participant: Participant
  withTeamColors?: boolean
  isDeleted?: boolean
}

const props = defineProps<Props>()

// data
const teamSide = getParticipantTeamSide(props.participant)

// computed
const textClass = computed(() => {
  if (!props.withTeamColors) {
    return ''
  }

  if (teamSide === 'home') {
    return props.isDeleted
      ? 'text-current-team-home-5/40'
      : 'text-current-team-home-5'
  }

  // away
  return props.isDeleted
    ? 'text-current-team-away-5/40'
    : 'text-current-team-away-5'
})
</script>

<template>
  <div :class="textClass">
    {{ participant.short_name }}
  </div>
</template>
